import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScheduleAppointmentComponent } from '../schedule-appointment/schedule-appointment.component';


const routes: Routes = [
  // { path: '', component: ScheduleAppointmentComponent },
  // { path: 'schedule-appointment', component: ScheduleAppointmentComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScheduleAppointmentRoutingModule { }
